var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-switch',{attrs:{"loading":_vm.loading,"inset":"","input-value":!!_vm.transaction.verified_at,"disabled":_vm.loading,"color":!!_vm.transaction.verified_at ? 'primary' : ''},on:{"change":_vm.toggleVerification}})
}
var staticRenderFns = []

export { render, staticRenderFns }